import { SET_PRODUCT_LIST, PRODUCT_LIST } from "../constants";

// Initial state for the product reducer
const initialState = {
  data: [],
  loading: false,
};

// Reducer to handle product data in the Redux store
export const productData = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_LIST:
      return { ...state, loading: true }; // fetching started
    case SET_PRODUCT_LIST:
      return { data: action.data, loading: false }; // fetching done
    default:
      return state;
  }
};
